.stand-notification-launcher {
  position: relative;
  z-index: 1;
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border: 1px solid var(--accent);
  border-radius: 50%;
  background: var(--surface-panel);
  color: var(--accent);
  box-shadow: 0 10px 28px #0008;
  cursor: pointer;
}
.stand-notification-launcher-label {
  position: absolute;
  top: calc(100% + 9px);
  right: 0;
  width: max-content;
  padding: 7px 10px;
  border: 1px solid var(--line-strong);
  border-radius: 5px;
  background: var(--surface-panel);
  color: var(--text);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.28);
  font-size: 11px;
  font-weight: 850;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-5px);
  transition: opacity 0.14s ease, transform 0.14s ease;
}
.stand-notification-launcher:hover .stand-notification-launcher-label,
.stand-notification-launcher:focus-visible .stand-notification-launcher-label {
  opacity: 1;
  transform: translateY(0);
}
.stand-notification-launcher svg {
  width: 15px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
}
.stand-notification-launcher > b {
  position: absolute;
  right: -5px;
  top: -6px;
  display: grid;
  min-width: 23px;
  height: 23px;
  padding: 0 4px;
  place-items: center;
  border: 2px solid var(--surface);
  border-radius: 12px;
  background: #ef3d55;
  color: #fff;
  font-size: 11px;
}
.stand-notification-launcher.has-unread {
  animation: chat-launcher-pulse 1.25s ease-in-out infinite;
}
.stand-notification-overlay {
  position: fixed;
  z-index: 5000;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 88px 24px 24px;
  background: rgba(4, 15, 12, 0.42);
  backdrop-filter: blur(4px);
  isolation: isolate;
}
.stand-notification-center {
  position: relative;
  z-index: 1;
  display: flex;
  width: min(470px, calc(100vw - 32px));
  height: min(700px, calc(100vh - 120px));
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--line-strong);
  border-radius: 8px;
  background: var(--surface-panel);
  color: var(--text);
  box-shadow: 0 22px 70px #0009;
}
.stand-notification-center > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid var(--line);
}
.stand-notification-center > header p,
.stand-notification-center > header h2 {
  margin: 0;
}
.stand-notification-center > header p {
  color: var(--accent);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.stand-notification-center > header button {
  width: 34px;
  height: 34px;
  border: 1px solid var(--line);
  background: transparent;
  color: var(--text);
  font-size: 22px;
}
.stand-notification-center > nav {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid var(--line);
}
.stand-notification-center > nav button {
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 12px;
  background: transparent;
  color: var(--muted);
  font-weight: 800;
}
.stand-notification-center > nav button.active {
  border-color: var(--accent);
  color: var(--accent);
}
.stand-notification-notice {
  margin: 10px;
  border: 1px solid var(--accent);
  padding: 9px;
  background: var(--accent-soft);
  color: var(--text);
  text-align: left;
}
.stand-notification-list,
.stand-support-list {
  display: grid;
  gap: 8px;
  overflow: auto;
  padding: 12px;
}
.stand-notification-list > p,
.stand-support-list > p {
  color: var(--muted);
}
.stand-notification-list article {
  display: grid;
  grid-template-columns: 1fr auto;
  border: 1px solid var(--line);
  background: var(--surface-panel);
}
.stand-notification-list article.unread {
  border-left: 3px solid var(--accent);
}
.stand-notification-list article > button:first-child,
.stand-support-list > button:not(.stand-support-new-button) {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  width: 100%;
  border: 0;
  padding: 13px;
  background: transparent;
  color: var(--text);
  text-align: left;
}
.stand-notification-list strong,
.stand-notification-list small,
.stand-notification-list time,
.stand-support-list strong,
.stand-support-list small,
.stand-support-list time {
  display: block;
}
.stand-notification-list small,
.stand-support-list small {
  margin-top: 4px;
  color: var(--muted);
}
.stand-notification-list time,
.stand-support-list time {
  margin-top: 5px;
  color: var(--muted);
  font-size: 10px;
}
.stand-notification-list em {
  color: var(--accent);
  font-size: 11px;
  font-style: normal;
}
.stand-notification-list .archive {
  width: 36px;
  border: 0;
  background: transparent;
  color: var(--muted);
}
.stand-support-new-button {
  border: 0;
  padding: 13px;
  background: var(--accent);
  color: #042019;
  font-weight: 900;
}
.stand-support-new {
  display: grid;
  gap: 14px;
  overflow: auto;
  padding: 18px;
}
.stand-support-new > div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.stand-support-new label {
  display: grid;
  gap: 6px;
}
.stand-support-new input,
.stand-support-new select,
.stand-support-new textarea,
.stand-support-conversation textarea {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid var(--line-strong);
  padding: 10px;
  background: var(--surface-panel);
  color: var(--text);
  font: inherit;
}
.stand-support-new footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.stand-support-new footer button,
.stand-support-conversation form button {
  border: 1px solid var(--line-strong);
  padding: 10px 14px;
  background: transparent;
  color: var(--text);
}
.stand-support-new footer .primary,
.stand-support-conversation form button {
  border-color: var(--accent);
  background: var(--accent);
  color: #042019;
  font-weight: 900;
}
.stand-support-conversation {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
}
.stand-support-back {
  border: 0;
  border-bottom: 1px solid var(--line);
  padding: 10px 16px;
  background: transparent;
  color: var(--accent);
  text-align: left;
}
.stand-support-title {
  display: grid;
  gap: 3px;
  padding: 13px 16px;
  border-bottom: 1px solid var(--line);
}
.stand-support-title small {
  color: var(--muted);
}
.stand-support-messages {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  overflow: auto;
  padding: 14px;
}
.stand-support-messages article {
  align-self: flex-start;
  max-width: 82%;
  border: 1px solid var(--line);
  padding: 10px;
  background: var(--surface-panel);
}
.stand-support-messages article.stand {
  align-self: flex-end;
  border-color: var(--accent);
}
.stand-support-messages p {
  margin: 0 0 5px;
  white-space: pre-wrap;
}
.stand-support-messages time,
.stand-support-messages small {
  display: block;
  color: var(--muted);
  font-size: 10px;
}
.stand-support-conversation form {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: end;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid var(--line);
}
@media (max-width: 600px) {
  .stand-notification-center {
    width: calc(100vw - 16px);
    height: calc(100vh - 92px);
  }
  .stand-notification-overlay {
    padding: 76px 8px 8px;
  }
  .stand-support-new > div {
    grid-template-columns: 1fr;
  }
}
